export const mutations = {
    setReporting: function(state, data) {
        let fill = [...data];
        let DRAFT = fill.filter((e) => e.Stage === 0);
        let PENDING = fill.filter((e) => e.Stage === 1);
        let PROCESS = fill.filter((e) => e.Stage === 2 || e.Stage === 3 || e.Stage === 4 || e.Stage === 5);

        let APPROVE = fill.filter((e) => e.Stage === 6 || e.Stage === 7 || e.Stage === 8);

        let REJECT = fill.filter((e) => e.Stage === -1);
        let DENY = fill.filter((e) => e.Stage === -2);

        var overAll = 0;

        if (DRAFT.length >= 1) {
            const index = [...state.reporting].findIndex((e) => e.Stage == "DRAFT");
            var total = 0;
            for(var i=0;i<DRAFT.length;i++){
                total += DRAFT[i].Value;
            }
            state.reporting[index].Value = total;
            overAll += total;
        }

        if (PENDING.length >= 1) {
            const index = [...state.reporting].findIndex((e) => e.Stage == "PENDING");
            var total = 0;
            for(var i=0;i<PENDING.length;i++){
                total += PENDING[i].Value;
            }
            state.reporting[index].Value = total;
            overAll += total;
        }

        if (PROCESS.length >= 1) {
            const index = [...state.reporting].findIndex((e) => e.Stage == "PROCESSING");
            var total = 0;
            for(var i=0;i<PROCESS.length;i++){
                total += PROCESS[i].Value;
            }
            state.reporting[index].Value = total;
            overAll += total;
        }
    
        if (APPROVE.length >= 1) {
            const index = [...state.reporting].findIndex((e) => e.Stage == "APPROVED");
            var total = 0;
            for(var i=0;i<APPROVE.length;i++){
                total += APPROVE[i].Value;
            }
            state.reporting[index].Value = total;
            overAll += total;
        }

        if (REJECT.length >= 1) {
            const index = [...state.reporting].findIndex((e) => e.Stage == "REJECT");
            var total = 0;
            for(var i=0;i<REJECT.length;i++){
                total += REJECT[i].Value;
            }
            state.reporting[index].Value = total;
            overAll += total;
        }

        if (DENY.length >= 1) {
            const index = [...state.reporting].findIndex((e) => e.Stage == "DENY");
            var total = 0;
            for(var i=0;i<DENY.length;i++){
                total += DENY[i].Value;
            }
            state.reporting[index].Value = total;
            overAll += total;
        }

        const index = [...state.reporting].findIndex((e) => e.Stage == "ALL");
        state.reporting[index].Value = overAll;
    },
    setGraph: function(state, data) {
        state.graph = data;
    }
} 